import React, { Component, ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: boolean;
  errorInfo: boolean;
}

const styles = {
  error: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#f98e7e",
    borderTop: "1px solid #777",
    borderBottom: "1px solid #777"
  }
};

const catchFunc = (error: Error, errorInfo: ErrorInfo, ctx: any) => {
  ctx.setState({
    error: error,
    errorInfo: errorInfo
  });
};

const handleError = (ctx: any) => (
  <div style={ctx.props.style || styles.error}>
    <h2>Something went wrong.</h2>
    <details style={{ whiteSpace: "pre-wrap" }}>
      {ctx.state.error && ctx.state.error.toString()}
      <br />
      {ctx.state.errorInfo.componentStack}
    </details>
  </div>
);

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: false, errorInfo: false };
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { error: true, errorInfo: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    catchFunc(error, errorInfo, this);
  }

  render() {
    if (this.state.error) {
      return handleError(this);
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
